// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#offers-examples .offers{gap:1rem}#offers-examples .offers .card-header{min-height:100px}\n", ""]);
// Exports
module.exports = exports;
